import React from 'react';
import { Box, Typography, Divider } from '@mui/material';

export default function TabSwitch({activeTab , setActiveTab}) {

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const tabs = [
    {
      label: 'Next Round Mock',
      icon: (isActive) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M2.99983 9C2.99983 4.58172 6.58125 1 10.9992 1C15.4171 1 18.9985 4.58172 18.9985 9C18.9985 10.15 18.7558 11.2434 18.319 12.2316L19 16.9992L14.9146 15.9778C13.7572 16.6287 12.4215 17 10.9992 17M1.00095 14C1.00095 14.7188 1.15258 15.4021 1.4256 16.0198L1 18.9995L3.55315 18.3611C4.27643 18.768 5.11115 19 6.00005 19C8.76098 19 10.9992 16.7614 10.9992 14C10.9992 11.2386 8.76098 9 6.00005 9C3.23912 9 1.00095 11.2386 1.00095 14Z"
            stroke={isActive ? "#003E8C" : "#3C434D"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    },
    {
      label: 'Coding Mock',
      icon: (isActive) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
          <path
            d="M8.59844 13.9984L5.59844 10.9984L8.59844 7.99844M13.3984 7.99844L16.3984 10.9984L13.3984 13.9984M3.79844 20.5984C2.47295 20.5984 1.39844 19.5239 1.39844 18.1984V3.79844C1.39844 2.47295 2.47295 1.39844 3.79844 1.39844H18.1984C19.5239 1.39844 20.5984 2.47295 20.5984 3.79844V18.1984C20.5984 19.5239 19.5239 20.5984 18.1984 20.5984H3.79844Z"
            stroke={isActive ? "#003E8C" : "#3C434D"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    },
    {
      label: 'Shortlisting Genie',
      icon: (isActive) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M5 8.33333V6.66667C5 3.90917 7.23858 1.66667 10 1.66667C12.7614 1.66667 15 3.90917 15 6.66667V8.33333M5 8.33333H15M5 8.33333H3.33333V16.6667C3.33333 17.5871 4.07953 18.3333 5 18.3333H15C15.9205 18.3333 16.6667 17.5871 16.6667 16.6667V8.33333H15"
            stroke={isActive ? "#003E8C" : "#6B7280"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        bgcolor: '#F8F9FA',
        borderRadius: '8px',
        padding: '4px',
        width: '100%',
      }}
    >
      {tabs.map((tab, index) => (
        <React.Fragment key={tab.label}>
          <Box
            component="button"
            onClick={() => handleTabClick(index)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '16px 38px',
              minWidth: '150px',
              minHeight: '40px',
              bgcolor: activeTab === index ? '#E5F1FF' : 'transparent',
              color: activeTab === index ? '#003E8C' : '#3C434D',
              border: 'none',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              position: 'relative',
              textAlign: 'left',
              '&:hover': {
                bgcolor: activeTab === index ? '#eaf2fd' : 'rgba(0, 0, 0, 0.04)',
              }
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {tab.icon(activeTab === index)}
            </Box>
            <Typography variant='h6-semiBold'>
              {tab.label}
            </Typography>
          </Box>
          
          {index < tabs.length - 1 && (
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                border: `1px solid #CCD4DE`
              }}
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
}